import 'slick-carousel';
import slickCss from 'slick-carousel/slick/slick.css';

class ImageCarousel {
  constructor($main) {
    if (!this.initDomElements($main)) {
      return false;
    }

    this.initCarousel();
  }

  initDomElements($main) {
    this.domElements = {};
    this.domElements.main = $main;
    if (this.domElements.main.length < 1) return false;
    this.domElements.items = this.domElements.main.find('.image-carousel__items');
    this.domElements.navigation = this.domElements.main.find('.image-carousel__control');
    return true;
  }

  initCarousel() {
    const slickConfig = {
      dots: true,
      arrows: true,
      slidesToShow: 1.2, // Show a portion of the next slide
      slidesToScroll: 1,
      speed: 1000,
      fade: false,
      autoplay: false,
      autoplaySpeed: 7000,
      adaptiveHeight: false,
      variableWidth: true,
      appendArrows: this.domElements.navigation,
      appendDots: this.domElements.navigation,
      infinite: false,
      centerMode: false
    };

    this.domElements.items.slick(slickConfig);
  }
}

export default ImageCarousel;
